module.exports = __webpack_public_path__ + "img/27.5c49ab46.jpeg";